import { Link } from 'react-router-dom'
import { EyeIcon } from '@heroicons/react/24/outline'
import { ROW_ACTION_ICON_CLASSES } from '../table/rowActions'

type Props = {
    accountId: number
    /**
     * 'icon' is a compact icon-only button for dense rows (the profile list);
     * 'default' keeps the labelled button used elsewhere (e.g. AccountSummary).
     */
    variant?: 'default' | 'icon'
}

/**
 * Displays a Dashoard button, linking to the given account's dashboard.
 */
export default function DashboardButton({ accountId, variant = 'default' }: Props) {
    if (variant === 'icon') {
        return (
            <Link
                className={ROW_ACTION_ICON_CLASSES}
                key={accountId}
                to={`/account/${accountId}`}
                data-cy="dashboard_button"
                title="View profile"
                aria-label="View profile"
            >
                <EyeIcon className="h-5 w-5" aria-hidden="true" />
            </Link>
        )
    }
    return (
        <Link
            className="inline-flex items-center rounded-md border border-ink-200 bg-white px-3 py-2 text-sm text-ink-700 shadow-sm hover:border-ink-300 hover:bg-ink-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-arwen-500"
            key={accountId}
            to={`/account/${accountId}`}
            data-cy="dashboard_button"
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-4 w-4 mr-2"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M7 12l3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z"
                />
            </svg>
            <span>Profile Dashboard</span>
        </Link>
    )
}
